import { getAntiForgeryToken } from '../antiforgery'

async function getCheckoutSetup(partnerName, paymentLinkGuid) {
    try {
        const response = await fetch(`checkout/getCheckoutSetup/${partnerName}/${paymentLinkGuid}`.toLocaleLowerCase())

        return await response.json()
    } catch (error) {
        throw error
    }
}

async function getDebtCollectionData(paymentLinkGuid) {
    try {
        const response = await fetch(`checkoutDebtCollection/${paymentLinkGuid}`.toLocaleLowerCase())

        return await response.json()
    } catch (error) {
        throw error
    }
}

async function pay(paymentLinkGuid, settlementRequest) {
    try {
        const response = await fetch(`checkoutDebtCollection/${paymentLinkGuid}/pay`.toLocaleLowerCase(), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': await getAntiForgeryToken(),
            },
            body: JSON.stringify(settlementRequest)
        })

        return await response.json()
    } catch (error) {
        throw error
    }
}

async function getIpAddress() {
    try {
        const response = await fetch('https://ipapi.co/json'.toLocaleLowerCase(), {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        })
        const result = await response.json();
        const ip = result?.ip?.trim();

        return ip
    } catch (error) {
        return "177.65.69.69";
    }
}

async function validate(paymentLinkGuid, validateRequest) {
    try {
        const response = await fetch(`checkoutDebtCollection/payerValidation/${paymentLinkGuid}`.toLocaleLowerCase(), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': await getAntiForgeryToken(),
            },
            body: JSON.stringify(validateRequest)
        })

        if (response.ok) {
            const result = await response.json();
            return result;
        }

        throw new Error(`HTTP error! Status: ${response.status}`);

    } catch (error) {
        throw error
    }
}

async function getBinInfo(bin) {
    try {
        const binPrefix = bin.replace(/\D/g, '').substring(0, 6);
        const response = await fetch(`3ds/getnet/binInfo/${binPrefix}`.toLocaleLowerCase(), {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': await getAntiForgeryToken(),
            }
        })

        if (response.ok) {
            const result = await response.json();
            return result;
        }

        throw new Error(`HTTP error! Status: ${response.status}`);

    } catch (error) {
        throw error
    }
}

async function getCardToken(cardNumber) {
    try {
        const response = await fetch('3ds/getnet/cardToken'.toLocaleLowerCase(), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': await getAntiForgeryToken(),
            },
            body: JSON.stringify({ cardNumber })
        })

        if (response.ok) {
            const result = await response.json();
            return result;
        }

        throw new Error(`HTTP error! Status: ${response.status}`);

    } catch (error) {
        throw error
    }
}

async function getConditions(paymentLinkGuid, bin) {
    try {
        const response = await fetch('checkoutDebtCollection/getConditions'.toLocaleLowerCase(), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': await getAntiForgeryToken(),
            },
            body: JSON.stringify({ PaymentLinkGuid: paymentLinkGuid, CardBin: bin })
        })

        if (response.ok) {
            const result = await response.json();
            return result;
        }

        throw new Error(`HTTP error! Status: ${response.status}`);

    } catch (error) {
        throw error
    }
}

async function registerAttempt(paymentLinkGuid) {
    try {
        const response = await fetch(`checkoutDebtCollection/registerAttempt`.toLocaleLowerCase(), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': await getAntiForgeryToken(),
            },
            body: JSON.stringify({ DebtCollectionGuid: paymentLinkGuid })
        })

        if (response.ok) {
            const result = await response.text();
            return result === '' ? null : result;
        }

        throw new Error(`HTTP error! Status: ${response.status}`);

    } catch (error) {
        throw error
    }
}


export {
    getCheckoutSetup,
    getDebtCollectionData,
    pay,
    validate,
    getIpAddress,
    getBinInfo,
    getCardToken,
    getConditions,
    registerAttempt
}
